<div class="row" style="margin-top: 15px">

  <div class="col-6">
    <div class="form-group">
      <mat-form-field style="width: 100%;">
        <input (change)="EmitFilterProspec()"  [(ngModel)]="prospect.nom_prenom"
          matInput placeholder="{{'languages.opportunite.label_nomandprenom' | translate}}" type="text">
      </mat-form-field>

    </div>
  </div>
  <div class="col-6">
    <div class="form-group">
      <mat-form-field style="width: 100%;">
        <!-- pattern="[0-9]{9}" -->
        <input (change)="EmitFilterProspec()"   name="phone"
          title="Three letter country code" [(ngModel)]="prospect.telephone" matInput placeholder="{{'languages.prospect.phone' | translate}}"
          type="number" #phone="ngModel">
      </mat-form-field>
      <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="message-erreur">
        <div *ngIf="phone.errors.pattern">
<i class="fa-solid fa-triangle-exclamation"></i>&nbsp;{{'languages.opportunite.check_phone9' | translate}}"
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <div class="form-group">
      <mat-form-field style="width: 100%;">
        <input (change)="EmitFilterProspec()"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" [(ngModel)]="prospect.adresse_mail" name="mail"
          #mail="ngModel" matInput placeholder="{{'languages.prospect.email' | translate}}" type="text">
      </mat-form-field>
      <div *ngIf="mail.invalid && (mail.dirty || mail.touched)" class="message-erreur">

        <div *ngIf="mail.errors.pattern">
<i class="fa-solid fa-triangle-exclamation"></i>&nbsp; "{{'languages.opportunite.check_invalidformat' | translate}}"
        </div>
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="form-group">
      <mat-form-field style="width: 100%;">
        <input (change)="EmitFilterProspec()"  [(ngModel)]="prospect.ville_CP"
          matInput placeholder="{{'languages.opportunite.label_villeCp' | translate}}" type="text">
      </mat-form-field>

    </div>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <div class="form-group">
        <mat-form-field style="width: 100%;">
            <input (change)="EmitFilterProspec()" [(ngModel)]="prospect.RS" matInput
                placeholder="{{ 'languages.prospect.RaisonSociale' | translate}}" type="text">
        </mat-form-field>
    </div>
</div>
  <div class="col-6">
    <div class="form-group">
      <ng-container >
        <mat-form-field style="width: 100%;">
          <mat-label>{{'languages.groupedactions.mots_cles' | translate}}</mat-label>
          <ng-container class="p-3" *ngIf="allTagsPros?.length === 0">
            <div class="row ">
                <div class="text-center m-auto">
                    <mat-spinner [diameter]="15"></mat-spinner>
                </div>
            </div>
        </ng-container>
          <mat-chip-list #tagsPros>
            <mat-chip *ngFor="let tags of ListTagsPros" [selectable]="selectable" [removable]="removable"
              (removed)="removeTagsProspect(tags)" (removed)="EmitFilterProspec()">
              {{tags}}
              <i class="fa-solid fa-circle-xmark" matChipRemove *ngIf="removable" style="color: gray;"></i>
            </mat-chip>
            <input (click)="EmitFilterProspec()" placeholder="{{'languages.opportunite.label_mots_cles_selectionner' | translate}}" #TagsProsInput
              [formControl]="tagsProsFromCtrl" [matAutocomplete]="autoTagsPros" [matChipInputFor]="tagsPros"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
          </mat-chip-list>
          <mat-autocomplete #autoTagsPros="matAutocomplete" (optionSelected)="selectedTagsProspect($event)">
            <mat-option *ngFor="let tags of filteredTagsPros | async" [value]="tags.id">
              {{tags.libelle}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </ng-container>
    </div>
  </div>
  <!-- <div class="col-6">
    <div class="form-group">
      <ng-container >
        <mat-form-field style="width: 100%;">
          <mat-label>Zone</mat-label>
          <ng-container class="p-3" *ngIf="allZones?.length === 0">
            <div class="row ">
                <div class="text-center m-auto">
                    <mat-spinner [diameter]="15"></mat-spinner>
                </div>
            </div>
        </ng-container>
          <mat-chip-list #Zone>
            <mat-chip *ngFor="let zone of ListZones" [selectable]="selectable" [removable]="removable"
              (removed)="removeZones(zone)" (removed)="EmitFilterProspec()">
              {{zone}}
              <i class="fa-solid fa-circle-xmark" matChipRemove *ngIf="removable" style="color: gray;"></i>
            </mat-chip>
            <input (click)="EmitFilterProspec()" placeholder="{{'languages.opportunite.label_zone_select' | translate}}" #ZonesInput
              [formControl]="zoneFromCtrl" [matAutocomplete]="autoZones" [matChipInputFor]="Zone"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
          </mat-chip-list>
          <mat-autocomplete #autoZones="matAutocomplete" (optionSelected)="selectedZones($event)">
            <mat-option *ngFor="let zone of filteredZones | async" [value]="zone.id">
              {{zone.nom}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </ng-container>
    </div>
  </div> -->
</div>
